module.exports = __webpack_public_path__ + "media/dogs/round-dog-avatar-b4bd3602.svg";